import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgPackage from "components/svg/SvgPackage";
import SvgUsers from "components/svg/SvgUsers";
import { Tab, Tabs } from "react-bootstrap"
import SvgShuffle from "components/svg/SvgShuffle";
import ObjectCardProducts from "./Tabs/ObjectCardProducts";
import ObjectCardServices from "./Tabs/ObjectCardServices";
import ObjectCardOther from "./Tabs/ObjectCardOther";
import SvgMenu from "components/svg/SvgMenu";
import ObjectCardEvents from "./Tabs/ObjectCardEvents";
import ObjectCardTasks from "./Tabs/ObjectCardTasks";
import SolarIcon from "components/icons/SolarIcon";
import useSettingsParams from "hooks/useSettingsParams";
import ObjectDiscussion from "../../ObjectCard/Discussion";
import DiscussionUnreadBadge from "../../ObjectCard/Discussion/DiscussionUnreadBadge";
import { useDiscussionUnread } from "../../ObjectCard/Discussion/model";

const OffObjectCardTabs = ({objectId, vobjectFull, setVobjectFull, fetchObject}) => {
    const { t } = useTranslation(['Objects']);
    const params = useSettingsParams();
    const canShowTasks = params.tasksModule && params.tasksForObjects;
    const [activeKey, setActiveKey] = useState('products');
    const discussionObjectId = Number(objectId) || 0;
    const { unreadCount, clearUnread } = useDiscussionUnread(discussionObjectId, 'team', true);

    return (
        <div className="off-object-4team-tabs">
        <Tabs
            variant="underline"
            activeKey={activeKey}
            onSelect={(key) => { if (key) setActiveKey(key); }}
            className="mb-3 invoice-tab border-bottom px-3 flex-shrink-0">
            
            <Tab eventKey="products" 
                title={(<><SvgPackage height={14} className="me-1"/>{t('infoItems.objectMaterials')}</>) }>
                    <ObjectCardProducts
                        vobjectFull={vobjectFull}
                        fetchObject={fetchObject}/>
            </Tab>

            <Tab eventKey="services"
                title={(<><SvgUsers height={14} className="me-1"/>{t('infoItems.objectServices')}</>) }>
                    <ObjectCardServices
                        objectId={objectId}
                        vobjectFull={vobjectFull}
                        fetchObject={fetchObject}/>
            </Tab>

            <Tab eventKey="other"
                title={(<><SvgShuffle height={14} className="me-1"/>{t('infoItems.objectOther')}</>) }>
                    <ObjectCardOther
                        setVobjectFull={setVobjectFull}
                        fetchObject={fetchObject}    
                        objectId={objectId}
                        vobjectFull={vobjectFull}/>
            </Tab>

            {canShowTasks && (
            <Tab eventKey="tasks"
                title={(<><SolarIcon name="clipboard-check" className="me-1 fs-14"/>{t('infoItems.objectTasks')}</>)}
                mountOnEnter>
                <ObjectCardTasks objectId={objectId}/>
            </Tab>
            )}
 
            {vobjectFull?.events?.length > 0 &&
            (<Tab eventKey="events"
                title={(<><SvgMenu height={14} className="me-1"/>{t('infoItems.objectEvents')}</>) }>
                <ObjectCardEvents
                    vobjectFull={vobjectFull}/>
            </Tab>)}

            <Tab
                className="px-2"
                eventKey="discussion"
                mountOnEnter
                unmountOnExit
                title={(
                    <>
                        <SolarIcon name="chat-left-text" className="me-1 fs-14"/>
                        {t('infoItems.objectDiscussion')}
                        {activeKey !== 'discussion' ? (
                            <DiscussionUnreadBadge count={unreadCount} />
                        ) : null}
                    </>
                )}
            >
                <ObjectDiscussion
                    objectId={discussionObjectId}
                    channel="team"
                    onSeen={clearUnread}
                />
            </Tab>
                                    
        </Tabs>
        </div>
    )
}

export default OffObjectCardTabs;